import { MEDIA_TYPES } from '../../constants';

export const MEDIA_LINK_VARIANTS = {
  THUMBNAIL: 'thumbnail',
  DISPLAY: 'display',
};

export function resolveActiv8MediaLink(slide, variant = MEDIA_LINK_VARIANTS.DISPLAY) {
  if (!slide) {
    return { src: null, poster: null, backgroundSrc: null };
  }

  const { thumbnailLink, contentDisplayLink, mediaType } = slide;
  const isVideo = mediaType === MEDIA_TYPES.VIDEO;
  const backgroundSrc = !isVideo ? thumbnailLink || null : null;

  if (variant === MEDIA_LINK_VARIANTS.THUMBNAIL) {
    if (isVideo) {
      return {
        src: contentDisplayLink || null,
        poster: thumbnailLink || null,
        backgroundSrc,
      };
    }

    return {
      src: thumbnailLink || null,
      poster: null,
      backgroundSrc,
    };
  }

  return {
    src: contentDisplayLink || thumbnailLink || null,
    poster: isVideo ? thumbnailLink || null : null,
    backgroundSrc,
  };
}
